"use client";

import { useEffect } from 'react';
import { useSidebar } from '@/components/ui/sidebar';

/** Expanded audio windows leave only the compact navigation visible. */
export function useCloseMenuWhenOpen(open: boolean) {
  const { setOpenMobile, setDisplayMode } = useSidebar();
  useEffect(() => {
    if (!open) return;
    setOpenMobile(false);
    setDisplayMode('icon');
  }, [open, setOpenMobile, setDisplayMode]);
}
